"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRID = void 0;
exports.GRID = {
    initialPage: 1,
    initialOffset: 0,
    pageLimit: 200,
};
//# sourceMappingURL=grid.js.map